import { ATBError } from './ATBError';

export class ATBValidationError extends ATBError {
  /**
   * @param {string} message
   */
  constructor(message) {
    super(message);
    this.name = 'ATBValidationError';
  }
}
